import { compact, uniqBy } from 'lodash'

import { useAuthUser } from '~/hooks/useAuthUser'
import { BackendSmartAccount, BackendTransaction } from '~/types'
import { plural } from '~/utils/display'

export const WaitingForMoreSignaturesTooltip = ({
  numMissingSignatures,
  smartAccount,
  transaction,
}: {
  numMissingSignatures: number
  smartAccount: BackendSmartAccount
  transaction: BackendTransaction
}) => {
  const { user: authUser } = useAuthUser()

  const remainingSignerUsers = !smartAccount.isPublicSmartAccount
    ? uniqBy(
        compact(
          smartAccount.signers
            .filter((accountSigner) => {
              const hasAlreadySigned = transaction.signers.some(
                (transactionSigner) =>
                  transactionSigner.id === accountSigner.id,
              )
              return !hasAlreadySigned
            })
            .map((signer) => signer.user),
        ),
        'id',
      )
    : []

  return (
    <div>
      <span className="flex items-center gap-1">
        You&apos;ve signed. {numMissingSignatures}{' '}
        {plural('approval', numMissingSignatures)} needed:
      </span>
      <div className="space-y-1">
        {remainingSignerUsers.map((user, index) => (
          <div key={index} className="text-secondary">
            {user.id === authUser?.id ? `You (${user.email})` : user.email}
          </div>
        ))}
      </div>
    </div>
  )
}
